<div *ngIf="PlatformService.isMobile()" [ngStyle]="UIUtilityService.getMobilePreLoadPageBackgroundStyle()"></div>

<app-spinner></app-spinner>

<ng-container>
	<ng-container [ngSwitch]="(this.srvError.systemAvailable | async)">
		<ng-container *ngSwitchCase="true">
			<ng-container *ngTemplateOutlet="SYSTEM_AVAILABLE"></ng-container>
		</ng-container>
		<ng-container *ngSwitchCase="false">
			<ng-container *ngTemplateOutlet="SYSTEM_NOT_AVAILABLE"></ng-container>
		</ng-container>
	</ng-container>
</ng-container>

<ng-template #SYSTEM_AVAILABLE>
	<router-outlet *ngIf="PlatformService.isBrowser()"></router-outlet>
	<ion-app *ngIf="PlatformService.isMobile()">
		<ion-router-outlet></ion-router-outlet>
	</ion-app>
</ng-template>


<ng-template #SYSTEM_NOT_AVAILABLE>
	<app-system-unavailable [error]="(this.srvError.systemUnAvailableError | async) ?? {}"></app-system-unavailable>
</ng-template>